module.exports = __webpack_public_path__ + "static/media/card-icon-2.598fde2a.svg";